var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 10C9.84375 10 8.96875 10.875 8.96875 12C8.96875 13.0938 9.84375 14 10.9688 14C12.0625 14 12.9688 13.0938 12.9688 12C12.9688 10.875 12.0938 10 10.9688 10ZM11 5C8.78125 5 6.6875 5.78125 5.03125 7.25C4.625 7.625 4.59375 8.25 4.9375 8.6875C5.3125 9.09375 5.9375 9.125 6.34375 8.75C7.625 7.625 9.28125 7 11 7C12.6875 7 14.3438 7.625 15.625 8.75C15.8125 8.9375 16.0312 9 16.2812 9C16.5625 9 16.8125 8.90625 17.0312 8.6875C17.4062 8.25 17.3438 7.625 16.9375 7.25C15.2812 5.8125 13.1875 5 11 5ZM20.6875 3.90625C18.0625 1.40625 14.625 0 11 0C7.34375 0 3.90625 1.40625 1.28125 3.90625C0.90625 4.28125 0.875 4.9375 1.25 5.3125C1.65625 5.71875 2.28125 5.75 2.6875 5.34375C4.90625 3.1875 7.875 2 11 2C14.0938 2 17.0312 3.1875 19.2812 5.34375C19.5 5.53125 19.75 5.625 20 5.625C20.25 5.625 20.5 5.53125 20.7188 5.3125C21.0938 4.9375 21.0625 4.28125 20.6875 3.90625Z",
    fill: "#0B213E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.5d6393922c42d9468bc4756a1199f31f.svg";
export { ForwardRef as ReactComponent };